<template>
  <section class="cl-gradient-blue-bg " id="particle">
    <div class="container">
      <h2 class="cl-heading mb-3 mb-md-5 txt-white text-center">انتخاب درست دانش آموزان سال‌های گذشته</h2>
      <h3 class="top-student-slider-title mb-3 mb-md-4 txt-white text-center">رتبه های برتر کلاسینو در <strong>کنکور ۱۴۰۲</strong></h3>
      <div class="cl-top-students-wrapper">
        <TopStudentsSlider :students="topStudent1402" />
      </div>

      <div class="text-center  mt-4 mb-4 mb-md-0">
        <router-link to="top_students1402" class="btn cta-btn orange mb-5">
          نمایش رتبه های برتر کنکور ۱۴۰۲
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>

import {TopStudents1402} from '@/constants/TopStudent'
import TopStudentsSlider from "@/components/slider/TopStudentsSlider.vue";

export default {
  name: "TopStudents",
  components: {
    TopStudentsSlider,
  },
  data() {
    return {
      topStudent1402: TopStudents1402,
    }
  }
}
</script>

<style lang="scss">
#particle {
  position: relative;
  background: url("../../assets/images/top_students/1402/whole back.jpg") no-repeat;
  background-size: cover;
  & > div{
    position: relative;
    z-index: 1;
  }
}
.top-student-slider-title{
  font-size: 27px;
  font-weight: 800;
  color: #ffffff;
  strong{
    color:#FFD843 ;
    font-weight: 900;
  }
}

.particles-js-canvas-el {
  position: absolute;
  top: 0;
  z-index: 0;
  //display: none;
}
</style>
